import { Outlet } from "react-router-dom";
import { Breadcrumbs, CompressingMenu, DataGridPage } from "@synota-io/synota-shared-ui";
import { useContractLinks } from "./hooks/useContractLinks";
import { LoadingContractBlock } from "./components/LoadingContractBlock";

export const ContractReportsOutlet = () => {
  const { menuLinks, matchedLinks, contract, isPending } = useContractLinks();

  return !contract ? (
    <LoadingContractBlock isLoading={isPending} />
  ) : (
    <DataGridPage
      actions={(maxWidth) => {
        return <CompressingMenu primaryActions={menuLinks} maxWidth={maxWidth} />;
      }}
      title={<Breadcrumbs links={matchedLinks} />}
    >
      <Outlet />
    </DataGridPage>
  );
};
